let id = 0;

export function uuid() {
    return ++id;
}
